import { Attachment, UUID } from '@/types/types';
import { ApiQueryKey } from '@/configs/ApiQueryKey';
import { ProductType } from './ProductTypeApi';
import EntityApi, { BaseEntity } from './EntityApi';
import { FormStatus } from './FormApi';
import httpClient from './httpClient';

export interface QuantityPerDimension {
	width: number;
	height: number;
	depth: number;
	quantity: number;
}

export interface FormQuestion {
	questionId: UUID;
	name: string;
	questionGroup: string;
}

export interface FormAnswer {
	answerId: UUID;
	question: FormQuestion;
	answer: string;
	files: Attachment[];
}

export enum ProjectStatus {
	NEW = 'NEW',
	IN_VALUATION = 'IN_VALUATION',
	READY_TO_ORDER = 'READY_TO_ORDER',
	IN_PROGRESS = 'IN_PROGRESS',
	COMPLETED = 'COMPLETED',
}

export interface CreatorProjectUploadMeta {
	id: string;
	label?: string;
	attachment: Attachment;
}

export interface CreatorProject {
	id: string;
	projectId?: string;
	productTypeId?: string;
	productType?: ProductType;
	configuration?: Record<string, unknown>;
	personalization?: Record<string, unknown>;
	uploads?: Record<string, unknown>[];
	uploadsMeta?: CreatorProjectUploadMeta[];
	metadata?: Record<string, unknown>;
	status?: 'draft' | 'submitted' | 'ordered';
}

export interface UserProject extends BaseEntity {
	projectId: string;
	externalOrderID?: string;
	status: ProjectStatus;
	price?: number;
	isPriceAccepted?: boolean;
	user?: {
		name: string;
		email: string;
		phone: string;
		companyName?: string;
		NIP?: string;
		city?: string;
		postalCode?: string;
		address?: string;
		street?: string;
	} | null;
	form?: {
		userData?: {
			name: string;
			email: string;
			phone: string;
			companyName?: string;
			NIP?: string;
			city?: string;
			postalCode?: string;
			address?: string;
		} | null;
		shippingData: {
			city: string;
			address: string;
			postalCode: string;
		};
		quantity: number;
		orderDate: string;
		formId: UUID;
		note?: string;
		quantityPerDimension: QuantityPerDimension[];
		formAnswers: FormAnswer[];
		productType: {
			id: string;
			name: string;
		};
		status: FormStatus;
	};
	creatorProject?: CreatorProject | null;
	createdAt: string;
	updatedAt: string;
}

class ProjectsApi extends EntityApi<UserProject> {
	constructor() {
		super(ApiQueryKey.projects);
	}

	async copy(projectId: string) {
		const response = await httpClient.post<UserProject>(`${this.queryKey}/${projectId}/copy`);
		return response.data;
	}
}

export default new ProjectsApi();
